import {combineReducers} from 'redux';
import login from "./login";
import loader from "./loader";
import crud from "./crud";
import theme from "./theme";
import spendingcontrol from "./spendingcontrol";
import user from "./user";
import feature from "./feature";
import signalr from "./signalr";
import investmentaccount from "./investmentaccount";

const rootReducer = combineReducers({
    login, 
    loader,
    crud,
    theme,
    spendingcontrol,
    user,
    feature,
    signalr,
    investmentaccount
});

export default rootReducer;